import React from 'react';
import { Dialog, DialogContent, Icon, IconButton, Typography, Button } from '@material-ui/core';
import { resourceFormStyle } from '../../css/style';
import customizationLogo from '../../assets/img/customization_logo.svg';
import PropTypes from 'prop-types';

const styles = resourceFormStyle();

const InvalidVariationDialog = props => (
  <Dialog open={!!props.invalidVariationDialogOpen} onClose={props.closeDialog}>
    <DialogContent style={styles.addItemCusDialogContainer}>
      <IconButton style={styles.itemCusDialogCloseBtn} onClick={props.closeDialog}>
        <Icon>close</Icon>
      </IconButton>
      <img src={customizationLogo} style={{ marginTop: '50px' }} />
      <Typography style={styles.itemCusDialogTitle}>ALMOST THERE!</Typography>
      <Typography style={styles.dialogDescription}>
        You need to have at least one variation or product item, and all your variations or product items must
        have the Name, Attribute Name, Attribute Value, and Price fields filled out if they show up on the screen. You also must have exactly one item as
        {` the default that is not disabled, you currently have ${props.numberOfDefaultItems} default item(s).`}
      </Typography>
      <Button style={styles.itemCusBtnInDialog} onClick={props.closeDialog}>
        CLOSE
      </Button>
    </DialogContent>
  </Dialog>
);

InvalidVariationDialog.propTypes = {
  invalidVariationDialogOpen: PropTypes.bool,
  onClose: PropTypes.func,
  numberOfDefaultItems: PropTypes.number,
};

export default InvalidVariationDialog;
